import React from "react";

const Info  = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path className="u_fill" d="M25.31 8.42H31l-6-5.88v5.58c.01.17.14.3.31.3z" fill={fill} />
      <path className="u_fill"
          d="M25.3 10.3c-1.2 0-2.17-.98-2.17-2.18V2H7.51C5.57 2 4 3.57 4 5.5v25C4 32.43 5.57 34 7.51 34h20.54c1.93 0 3.51-1.57 3.51-3.5V10.3H25.3zm.21 15.3h-15.2v-1.89h15.2v1.89zm0-4.74h-15.2v-1.89h15.2v1.89zm0-4.74h-15.2v-1.89h15.2v1.89z"
            fill={fill}
      />

    </svg>
);

export default Info;
